import { Button, Container, List } from '@mhub/web-components';
import React from 'react';
import { Link } from 'react-router-dom';
import AppHeader from '../../components/AppHeader';
import AppFooter from '../../components/Footer';
import './styles.css';

const RegisterRedirect = () => (
  <Container className="RegisterRedirect" scrollable noContent>
    <AppHeader header="Register">
      <p>
        I am a...
      </p>
    </AppHeader>
    <List
      data={[
        {
          title: 'Property Developer',
          href: 'https://mhub.my/register/developer/',
          color: 'blue',
          icon: 'agent',
        },
        {
          title: 'Mortgage Banker',
          href: 'https://mhub.my/register/banker/',
          color: 'blue',
          icon: 'banker',
        },
        // {
        //   title: 'Agency / Agent',
        //   href: 'https://mhub.my/agents/',
        //   color: 'blue',
        //   icon: 'leads',
        // },
      ]}
      itemNode={({
        color,
        icon,
        href,
        title,
      }) => (
        <List.Item
          key={href}
        >
          <Button
            ripple
            outline
            textAlign="center"
            as="a"
            color={color}
            icon={icon}
            href={href}
            className="Redirect-Button"
          >
            {title}
          </Button>
        </List.Item>
      )}
    />
    <AppFooter>
      <p>
        Already have an account?&nbsp;
        <Button
          basic
          as={Link}
          color="blue"
          to="/login"
          replace
        >
          Log in here.
        </Button>
      </p>
    </AppFooter>
  </Container>
);

export default RegisterRedirect;
